export const ANALYTICS_EVENTS_CONSENT_CATEGORY = 'performance'
